export default __webpack_public_path__ + "static/media/sbtc.792f2995.svg";